const ReducerFactory = {};

ReducerFactory.total = (total, value) => total + value;
ReducerFactory.avg = (avg, value, _, { length }) => avg + value / length;

export default ReducerFactory;
